// extracted by mini-css-extract-plugin
module.exports = {"WA_email":"WA_email_WA_email__2tpMi","WhatsAppIcon":"WA_email_WhatsAppIcon__dHRYr","MailOutlineIcon":"WA_email_MailOutlineIcon__1X0VR"};